module.exports = __webpack_public_path__ + "static/media/hotspot-dot.801ebbfc.png";